import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import theme from './styles/theme';
import './styles/main.scss';

import termsAndConditionsPDF from './static/terms-and-conditions-nyk.pdf';
import App from './App';

// Load FontAwesome icon packs
library.add(fab);
library.add(fas);
library.add(far);

ReactDOM.render(
  <ChakraProvider theme={theme}>
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<App />} />
        <Route
          path="/terms-and-conditions"
          element={
            <object
              type="application/pdf"
              data={termsAndConditionsPDF}
              width="100%"
              height="100%"
              aria-label="Terms and Conditions"
            >
              Your browser does not support the <code>object</code> element.
            </object>
          }
        />
      </Routes>
    </BrowserRouter>
  </ChakraProvider>,
  document.getElementById('root'),
);
